export default "__VITE_ASSET__DpLrGJPY__"